import visualsJson from './visuals.json';
import { VisualCard, VisualsSchema } from '../schemas/visual';

export type { VisualCard };
export const VISUALS: VisualCard[] = VisualsSchema.parse(visualsJson);
